import { WorkpaperProcedure, WorkpaperProcedureResult, WorkpaperProceduresGroup } from '../../types/workpaper-procedure';
import WorkpaperProcedureCategorySection from './WorkpaperProcedureCategorySection';

type WorkpaperProceduresTableProps = {
    selectedProcedures: WorkpaperProcedure[];
    otherProceduresGroup: WorkpaperProceduresGroup;
    categoryGroups: WorkpaperProceduresGroup[];
    workpaperProcedures: WorkpaperProcedureResult[];
    onProcedureChecked: (procedure: WorkpaperProcedure) => void;
    onToggleCollapse: (categoryId: string) => void;
};

function WorkpaperProceduresTable({
    selectedProcedures,
    otherProceduresGroup,
    categoryGroups,
    workpaperProcedures,
    onProcedureChecked,
    onToggleCollapse,
}: WorkpaperProceduresTableProps): JSX.Element {
    return (
        <div className="max-w-[100%] mx-auto">
            {workpaperProcedures?.length === 0 && <p className="block text-center text-sm text-gray-500 pt-4">No procedures</p>}

            {categoryGroups.map((cg) => {
                return (
                    <WorkpaperProcedureCategorySection
                        selectedProcedures={selectedProcedures}
                        key={cg.categoryId}
                        categoryDetails={cg}
                        onProcedureChecked={onProcedureChecked}
                        onToggleCollapse={onToggleCollapse}
                    />
                );
            })}

            {otherProceduresGroup.procedures.length > 0 && (
                <WorkpaperProcedureCategorySection
                    selectedProcedures={selectedProcedures}
                    categoryDetails={otherProceduresGroup}
                    onProcedureChecked={onProcedureChecked}
                    onToggleCollapse={onToggleCollapse}
                />
            )}
        </div>
    );
}

export default WorkpaperProceduresTable;
